import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import { SignatureCardProps } from "./SignatureCard.types";
import { StyledSignatureCard } from "./SignatureCard.styles";

const RoleCard: FC<SignatureCardProps> = ({
	className,
	children,
	backgroundColor = "primary_accent_500",
	borderRadius = "xl",
	...props
}) => {
	const block = new BemIt("SignatureCard");

	return (
		<StyledSignatureCard
			className={addClass(className).after(block)}
			backgroundColor={backgroundColor}
			borderRadius={borderRadius}
			{...props}
		>
			{children}
		</StyledSignatureCard>
	);
};

export default RoleCard;
